import { makeStyles, withStyles } from "@material-ui/core/styles";
import awsService from "../../assets/serviceimgs/aws1.png";
import googleService from "../../assets/serviceimgs/google2.png";
import microsoftService from "../../assets/serviceimgs/microsoft3.png";
import digitalService from "../../assets/serviceimgs/digital4.png";
import upcloudService from "../../assets/serviceimgs/upcloud5.png";
import Slider from "@material-ui/core/Slider";

const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

export const useStyles = makeStyles((theme) => ({
  mainTitle: {
    margin: 0,
    fontFamily: "Roboto-Medium",
    fontSize: "30px",
    color: "#091E42",
    paddingBottom: 20,
  },
  root: {
    backgroundColor: "#fff",
    padding: 12,
    borderRadius: 12,
    // width:1550
  },
  MainDiv: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    "@media (max-width: 1250px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  serviceText: {
    margin: 0,
    fontWeight: "500",
    fontSize: 26,
    color: "#091E42",
  },
  MainContainer: {
    width: "80%",

    // "@media (min-width: 1335px)": {
    //     width: '80%'
    // },
    "@media (max-width: 1250px)": {
      width: "100%",
    },
  },
 
  imgsContainer: {
    marginTop: 40,
  },
  serviceContainer: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 30,
    "@media (max-width: 360px)": {
      justifyContent:'center',
    
    },
  },

  awsService: {
    width: 116,
    height: 116,
    backgroundImage: `url(${awsService})`,
    backgroundSize:'50% 50%',
    backgroundSize: "cover",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border: "1px solid #D4DDE4",

    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },

  awsServiceActive: {
    width: 116,
    height: 116,
    backgroundImage: `url(${awsService})`,
    backgroundSize: "cover",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border:'2px solid #824ED2',

    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },

  googleService: {
    width: 116,
    height: 116,
    backgroundImage: `url(${googleService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  googleServiceactive: {
    width: 116,
    height: 116,
    backgroundImage: `url(${googleService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border:'2px solid #824ED2',
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  microsoftService: {
    width: 116,
    height: 116,
    backgroundImage: `url(${microsoftService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  microsoftServiceActive: {
    width: 116,
    height: 116,
    backgroundImage: `url(${microsoftService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border:'2px solid #824ED2',
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  digitalService: {
    width: 116,
    height: 116,
    backgroundImage: `url(${digitalService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,

    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  digitalServiceActive: {
    width: 116,
    height: 116,
    backgroundImage: `url(${digitalService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border:'2px solid #824ED2',
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  upcloudService: {
    width: 116,
    height: 116,
    backgroundImage: `url(${upcloudService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
  upcloudServiceActive: {
    width: 116,
    height: 116,
    backgroundImage: `url(${upcloudService})`,
    backgroundSize: "cover",
    border: "1px solid #D4DDE4",
    borderRadius: 1,
    marginRight:20,
    marginBottom:20,
    border:'2px solid #824ED2',

    "@media (max-width: 344px)": {
      width: 100,
    height: 100,
    },
  },
 
  selectServiceContainer: {
    marginTop: 40,
  },
  planServiceContainer: {
    marginTop: 40,
  },
  summaryContainer: {
    marginTop: 80,
    width: "19%",
    height: 785,
    backgroundColor: "#fff",
    borderRadius: 10,
    border: "1px solid #D4DDE4",
    marginLeft: 10,
    "@media (max-width: 1250px)": {
      width: "100%",
      height: 'auto',
      marginLeft: "0px",
    },
  },
  summaryInnerContainer: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  summaryHeader: {
    margin: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: "8px 0px",
    backgroundColor: "#824ED2",
    color: "#fff",
    fontWeight: "600",
    fontSize: 16,
    "@media (min-width: 1670px)": {
      fontSize: 20,
    },
    textAlign: "center",
  },
  summaryOne: {
    paddingTop: 15,
    paddingBottom: 12,
    borderBottom: "1px solid #D4DDE4",
  },
  summaryTwo: {
    paddingTop: 15,
    borderBottom: "1px solid #D4DDE4",
    paddingBottom: 12,
  },
  businessSummary: {
    display: "flex",
    alignItems: "center",
    width: "50%",
  },
  businessSummaryEnd: {
    display: "flex",
    alignItems: "center",
  },
  summaryTwoInner: {
    display: "flex",
    marginTop: 8,
  },
  p_Tag_Head: {
    margin: 0,
    color: "#091E42",
    fontWeight: "600",
    fontSize: 14,
    "@media (min-width: 1670px)": {
      fontSize: 16,
    },
  },
  p_Tag_Head_Price: {
    color: "#5B6773",
    margin: 0,
    fontWeight: "600",
    fontSize: 13,
    "@media (min-width: 1670px)": {
      fontSize: 16,
    },
  },
  p_Tag: {
    margin: 0,
    color: "#5B6773",
    fontWeight: "400",
    fontSize: 10,
    "@media (min-width: 1670px)": {
      fontSize: 14,
    },
  },
  p_Tag_Price: {
    margin: 0,
    color: "#091E42",
    fontWeight: "500",
    fontSize: 20,
    "@media (min-width: 1670px)": {
      fontSize: 26,
    },
    marginBottom: 10,
  },
  customBtn: {
    background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
    fontSize: 8,
    padding: "6px 4px",
    "@media (min-width: 1670px)": {
      padding: "6px 20px",
      fontSize: 12,
    },
    "@media (max-width: 1228px)": {
      padding: "6px 10px",
      // fontSize: 8,
    },
    marginTop: 15,
    width: "100%",
  },
  addIcon: {
    fontSize: "8px",
    "@media (min-width: 1670px)": {
      fontSize: 12,
    },
  
  },
  diskSpaceContainer: {
    backgroundColor: "#F4F6F8",
    border: "1px solid #D4DDE4",
    boxSizing: "border-box",
    borderRadius: "12px 0px 0px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "@media (max-width: 650px)": {
      flexDirection: "column",
    },
  },

  diskSpaceSlider: {
    paddingLeft:30,
    paddingRight:30,
    // paddingTop:30,
    height: 100,
    marginLeft: 30,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "75%",
    "@media (max-width: 650px)": {
      width: "100%",
      paddingTop:30,
      marginLeft:0,
      paddingLeft:20
    },
  },
  iosSlider: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // marginTop:30
    "@media (max-width: 650px)": {
      width: "100%",
      paddingTop:40
    },
  },

  diskSpaceSliderRight: {
    display: "flex",
    alignItems: "center",
    background: "#E6EDF3",
    width: "15%",
    height: "159px",
    padding: 20,
    borderLeft: "1px solid #D4DDE4",
    "@media (max-width: 650px)": {
      width:'100%',
      backgroundColor:'transparent'
    }
  },
  diskSpaceSliderRightText: {
    margin: 0,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 18,
    "@media (max-width: 700px)": {
      fontSize: 12,
    },
    "@media (max-width: 460px)": {
      fontSize: 10,
    },
    // letterSpacing: '-0.001em',
    color: "#5B6773",
  },
  diskSpacetext: {
    margin: 0,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 18,
    letterSpacing: "-0.001em",
    color: "#091E42",
  },
  mainInfo: {
    marginTop: 30,
  },
  infoContainer: {
    display: "flex",
    height: 92,
    border: "1px solid #00B9FF",
    borderRadius: 6,
    background: "rgba(3, 169, 244, 0.07)",
    "@media (max-width: 560px)": {
      height:'auto'
    },
  },
  imginfoDiv: {
    background: "rgba(3, 169, 244, 0.12)",
    borderRight: "1px solid #00B9FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 92,
  },
  textinfoDiv: {
    marginLeft: 30,
    "@media (max-width: 450px)": {
      marginLeft: 15,
    },
  },
  infoTopText: {
    "@media (max-width: 450px)": {
      margin: 0,
      margin: "10px 0px",
    },
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 16,
    color: "#091E42",
  },
  infoBottomText: {
    "@media (max-width: 450px)": {
      margin: 0,
    },
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 16,
    color: "#5B6773",
  },
  infoInput: {
    width: 220,
    height: 49,
    border: "1px solid #D4DDE4",
    boxSizing: "border-box",
    borderRadius: 4,
    outline: "none",
    color: "#5B6773",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 16,
    paddingLeft: 14,
  },
  companyName: {
    margin: 0,
    marginTop: 25,
    marginBottom: 10,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 16,
    color: "#091E42",
  },
  customThumbnailOne: {
    height: 36,
    width: 36,
    backgroundColor: "#824ED2",
    zIndex: 1000,
    marginTop: 2,
    marginRight: -22,
    borderRadius: 50,
    border: "2px solid #D4DDE4",
  },
  customThumbnailTwo: {
    height: 36,
    width: 36,
    backgroundColor: "#fff",
    borderRadius: 50,
    zIndex: 1000,
    marginLeft: -14,
    marginTop: 2,
    border: "2px solid #D4DDE4",
  },
}));

export const IOSSlider = withStyles({
  root: {
    color: "#3880ff",
    height: 12,
    padding: "15px 0",
    width: 400,
    //   width: '100%'
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: "#fff",
    marginTop: -11,
    marginLeft: -14,
    border: "2px solid #D4DDE4",
    "&:focus, &:hover, &$active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      boxShadow: "none",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: "none",
      },
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 12px)",
    top: -22,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  track: {
    height: 12,
    borderTop: "2px solid #D4DDE4",
    borderBottom: "2px solid #D4DDE4",
    backgroundColor: "#824ED2",
  },
  rail: {
    borderTop: "2px solid #D4DDE4",
    borderBottom: "2px solid #D4DDE4",
    height: 12,
    opacity: 0.5,
    backgroundColor: "#fff",
  },
  mark: {
    //   backgroundColor: '#824ED2',
    //   backgroundColor: 'green',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
    backgroundColor: "currentColor",
  },
})(Slider);
